<template>
    <div>
        This is for the , Bed set up interface.
    </div>
</template>

<script>
  export default {
    name: 'Beds',
  };
</script>

<style scoped>

</style>